import axios from "axios";

import { BASE_URL } from "./api";

// const ENDPOINT = `${BASE_URL}/pma_company_name_resolutions`;


export async function getPendingResolutions(payload) {
  // payload: { token, page, status='pending' }
  const params = new URLSearchParams();
  if (payload.status) params.set("status", payload.status);
  if (payload.page) params.set("page", payload.page);

  return axios({
    method: "get",
    url: `${BASE_URL}/pma_company_name_resolutions/?${params.toString()}`,
    headers: { Authorization: `Token ${payload.token}` },
  })
    .then((response) => ({
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      prev: response.data.previous,
      page: response.data.page,
      page_size: response.data.page_size,
      num_pages: response.data.num_pages,
    }))
    .catch((error) => { throw error; });
}


export async function resolvePMA(payload) {
  // payload: { token, id, company_id (int|null), confidence }
  return axios({
    method: "post",
    url: `${BASE_URL}/pma_company_name_resolutions/${payload.id}/resolve/`,
    headers: { Authorization: `Token ${payload.token}` },
    data: {
      company_id: payload.company_id,
      confidence: payload.confidence,
    },
  })
    .then((response) => response.data)
    .catch((error) => { throw error; });
}
